import {
  Component,
  OnInit
} from '@angular/core';
import {
  ApplicationService
} from '../../shared/services/application.service';
import {
  ChecklistConfigModel
} from '../../models/ChecklistModel';
import * as Constants from '../../models/Constants';
import {
  SettingsService
} from '../../shared/services/settings.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  FileUploader
} from 'ng2-file-upload';
import {
  UserDto
} from '../../models/User';
import {
  AccountService
} from '../../services/account.service';
import {
  ChecklistInstance,
  CheckListValueModel,
  PaymentInfo,
  RenewalApplication,
  FacilityView
} from '../../models/ApplicationModel';
import {DocumentRef} from '../../models/DocumentRef';
import {FacilityService} from '../../shared/services/facility.service';
import {environment} from '../../../environments/environment';
import {AlertService} from '../../shared/services/alert.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ApplicationDetail, DocumentDetail, FacilityDetail, PaymentInfoDetail, RenewalDraftApplicationModel, RenewalDraftDetail} from '../../models/ApplicationDetail';
import { NgxSpinnerService } from 'ngx-spinner';
import { RenewalFee } from '../../models/RenewalFee';
import { FIRItem } from '../../models/CommonModels';
import { ErisLoginService } from '../../services/sso/eris-login.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import {
  isSafeTextInput,
  NO_SCRIPT_INPUT_MESSAGE,
  withNoScriptValidators,
} from '../../shared/validators/no-script-input.validator';
const URL =  environment.baseUrl + '/Attachment';

@Component({
  selector: 'app-renew-application',
  templateUrl: './renew-application.component.html',
  styleUrls: ['./renew-application.component.css']
})
export class RenewApplicationComponent implements OnInit {

  public facilities: FacilityView[] = [];
  public tabList: Array < string > = ['renewalDetail', 'selfInspectionChecklist', 'fileAttachments', 'declaration'];
  public tab: string;
  public tabIndex: number;
  public buttonName: string;
  public renewalFee: RenewalFee;
  public showFee: boolean;
  public checklists: ChecklistConfigModel[];
  public checklistInstances: ChecklistInstance[] = [];
  public showChecklistItems: boolean;
  constants: any = Constants;
  public renewalForm: FormGroup;
  public user: UserDto;
  public uploader: FileUploader;
  public documents: Array < DocumentDetail > ;
  public documentRefs: Array < DocumentRef > ;
  public restrictedDocRefCount: number;
  public selectedFacilityId: number;
  public selectedFacilityCategoryName: string;
  public selectedFacility: FacilityView = null;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  private paymentInfo: PaymentInfo = null;
  private applicationId: number;
  private draftApplicationId: number;
  private applicationDetail: ApplicationDetail;
  private editMode = false;
  public editDocuments: Array < DocumentDetail > ;
  public renewalApplicationForEditing: RenewalApplication;
  public applicantAgreesWithDeclaration = false;
  public renewalDraft: RenewalDraftApplicationModel;
  public draftMode: boolean;
  public uploadErrorMessage = '';

  constructor(private applicationService: ApplicationService, private settingsService: SettingsService, private fb: FormBuilder,
    private accountService: AccountService, private facilityService: FacilityService, private alertService: AlertService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private erisLoginService: ErisLoginService, private errorHandlerService: ErrorHandlerService) {
      
      this.applicationId = this.route.snapshot.params['id'];
      this.selectedFacilityId = parseInt(this.route.snapshot.queryParams.facilityId);
      const draftMode = this.route.snapshot.params['draft'];
      this.draftMode = (/true/i).test(draftMode);

    }

  ngOnInit() {
    // initial setup
    this.uploader = new FileUploader({
      url: URL,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + this.accountService.getTokenData()
      }]
    });
   
    if (this.applicationId) {
      this.editMode = true;
      this.getApplicationForEditing();
    }
    this.facilityService.getFacilitiesForRenewal().subscribe(
      res => {
        if (res) {
        
          this.facilities = this.facilities.concat(res);
          if (this.selectedFacilityId) {
            this.selectedFacility = this.facilities.filter(facility => facility.id === this.selectedFacilityId)[0];
            this.selectedFacilityCategoryName = this.selectedFacility.facilityCategoryName;
            this.facilitySelected();
          }
        } else {
          console.log('Error fetching facilities');
        }
      }, err => {
        console.log('Error fetching facilities ' + err);
        this.alertService.error('Error fetching facilities, ' + this.errorHandlerService.handleApiError(err));
      }
    );
    this.buttonName = 'Next';
    this.tabIndex = 0;
    this.tab = this.tabList[this.tabIndex];
    this.user = this.accountService.getUserData();
    this.documents = [];
    this.documentRefs = [];
    this.initializeForm();

  }
  
  setRenewalApplicationVals(application){
    this.applicationDetail = application;
    this.facilities = this.facilities.concat(application.facility)
    this.editDocuments = application.documents;
    this.selectedFacility = application.facility;
    this.selectedFacilityId = application.facility.id;
    this.applicationId = application.id;
    const paymentInfo: PaymentInfoDetail = application.paymentInfos ? 
      (application.paymentInfos.length ? application.paymentInfos[application.paymentInfos.length - 1] : new PaymentInfoDetail({})) : new PaymentInfoDetail({});
    this.renewalForm.get('paymentInfo').get('receiptNumber').setValue(paymentInfo.recieptNumber);
    this.paymentInfo = new PaymentInfo(paymentInfo); 
    this.facilitySelected();
  }

  getApplicationForEditing() {
    if(this.draftMode){
      this.draftApplicationId = this.applicationId;
      this.applicationId = null;
        this.applicationService.getDraftApplication(this.draftApplicationId).subscribe(
          res => {
            var draftApplication: RenewalDraftDetail = new RenewalDraftDetail(res);
            // this.applicantAgreesWithDeclaration = draftApplication.agreedWithDeclaration;
            this.setRenewalApplicationVals(draftApplication);
          },
          err => {
            this.alertService.error('Unable to fetch draft application for editing. Please try again later.');
          }
        );
    }
    else{
      this.applicationService.getApplication(this.applicationId).subscribe(
        res => {     
          this.applicationDetail = new ApplicationDetail(res, null);
          this.setRenewalApplicationVals(this.applicationDetail);
        },
        err => {
          this.alertService.error('Unable to fetch application for editing. Please try again later.');
        }
      );
    }
  }

  initializeForm() {
    this.renewalForm = this.fb.group({
      checklist: this.fb.group({}),
      paymentInfo: this.fb.group({
        receiptNumber: ['', withNoScriptValidators([Validators.required])]
      })
    });
  }
  tabClicked(tab) {
    this.tab = tab;
    this.tabIndex = this.tabList.indexOf(tab);
    this.setButtonName();
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  facilitySelected() {
    this.checklistInstances = [];
    this.documents = [];
    if (this.renewalFee) {
      this.renewalFee = null;
      this.calculateFee();
    }
    this.selectedFacility = this.facilities.find(fac => fac.id === this.selectedFacilityId);

    if(!this.selectedFacility.productTypeID){
      this.selectedFacility.productTypeID = this.applicationDetail.productTypeID;
    }

    this.selectedFacilityCategoryName = this.selectedFacility.facilityCategoryName;

    let checklistFormGroup = this.renewalForm.get('checklist') as FormGroup;
    Object.keys(checklistFormGroup.controls).forEach(control => {
      checklistFormGroup.removeControl(control);
    });

    this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(this.selectedFacility.facilityTypeID,
      this.selectedFacility.productTypeID, 2, this.selectedFacility.facilityCategoryID,null).subscribe(
      res => {
        let itemValue;
        if (res.length) {
          this.showChecklistItems = true;
          this.checklists = res.filter(c => c.active);
          this.checklists.forEach(item => {

            itemValue = this.returnFormValues(item);
            if (item.required) {
              checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue, [Validators.required]));
            } else {
              checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue));
            }
          });

        } else {
          this.showChecklistItems = false;
        }
      }
    );

    this.applicationService.getRequiredDocumentsForRenewal(this.selectedFacility.facilityTypeID, this.selectedFacility.productTypeID,
      2, this.selectedFacility.facilityCategoryID).subscribe(
      documents => {
        this.documentRefs = documents;
        const restrictedDocs = this.documentRefs.filter(function (x) {
          return x.required === true;
        });
        this.restrictedDocRefCount = restrictedDocs.length;
      }
    );
  }

  returnFormValues(item) {
    const checklistFormGroup = this.renewalForm.get('checklist') as FormGroup;
    if (this.editMode) {
      const idx = this.applicationDetail.checkListItems.findIndex(it => {
        return item.checklistID === it.checklistID;
      });
      if (idx > -1) {
        return this.applicationDetail.checkListItems[idx].checkListValue.name;
      }
    }
    return checklistFormGroup.get(item.checklist.id.toString()) ? checklistFormGroup.get(item.checklist.id.toString()).value : '';
  }

  calculateFee() {
    const selectedFacility: FacilityView = this.facilities.find(fac => fac.id === this.selectedFacilityId);
    this.showFee = true;

    this.applicationService.calculateFeeForFacilityRenewal(selectedFacility.id).subscribe(
      res => {
        if (res) {
          this.renewalFee = res;
        }
      },
      err => {
        console.log('Error trying to fetch renewal fee' + err);
      }
    );
  }

  nextClicked() {
    if (this.tabIndex + 1 < this.tabList.length) { // 1 < 3 2 < 3
      this.tabIndex++;
      this.tab = this.tabList[this.tabIndex];
      this.setButtonName();
    } else if (this.tabIndex + 1 === this.tabList.length) {
      this.submitClicked();
    }
  }

  setButtonName() {
    if (this.tab === 'declaration') {
      this.buttonName = 'Submit';
    } else {
      this.buttonName = 'Next';
    }
  }

  retrievePaymentDetail(detail) {
    if (detail?.recieptNumber && !isSafeTextInput(detail.recieptNumber)) {
      this.alertService.error(NO_SCRIPT_INPUT_MESSAGE);
      this.paymentInfo = null;
      return;
    }
    this.paymentInfo = detail;
    console.log('payment detail ', detail);
  }

  private hasUnsafePaymentReceipt(): boolean {
    const receiptControl = this.renewalForm?.get('paymentInfo')?.get('receiptNumber');
    if (receiptControl?.hasError('noScriptInput')) {
      return true;
    }
    return !!(this.paymentInfo?.recieptNumber && !isSafeTextInput(this.paymentInfo.recieptNumber));
  }

  createChecklistObject() {
    this.checklistInstances = [];
    let controlArray = Object.keys(this.renewalForm.get('checklist')['controls']);

    for (let checklistControl of controlArray) {
      if (this.renewalForm.get('checklist').get(checklistControl).value.length) {
        const checklistRefIndex = this.checklists.findIndex(item => item.checklist.id.toString() === checklistControl);
        const newChecklistItem: ChecklistInstance = new ChecklistInstance();
        const checklistValue: CheckListValueModel = new CheckListValueModel();
        checklistValue.valueCode = this.renewalForm.get('checklist').get(checklistControl).value.toString().toUpperCase();
        checklistValue.name = this.renewalForm.get('checklist').get(checklistControl).value.toString();
        newChecklistItem.checkListValue = checklistValue;
        newChecklistItem.checklistID = this.checklists[checklistRefIndex].checklist.id;
        newChecklistItem.applicationID = this.applicationDetail ? this.applicationDetail.id : undefined;
        this.checklistInstances.push(newChecklistItem);
      }
    }
  }

  checkAllRequiredDocsUploaded() {
    // TODO: invalid validation, needs fixing
    return this.documents.length >= this.restrictedDocRefCount;
  }

  saveRenewal() {
    if (this.hasUnsafePaymentReceipt()) {
      this.alertService.error(NO_SCRIPT_INPUT_MESSAGE);
      return;
    }
    this.createChecklistObject();
    this.ensurePaymentPayload();
    const renewalApplicationDraft = new RenewalApplication( this.selectedFacility, this.documents,
      this.checklistInstances, this.paymentInfo, this.applicationDetail ? this.applicationDetail.id : null, this.applicantAgreesWithDeclaration);
    renewalApplicationDraft.productTypeID = this.applicationDetail ? this.applicationDetail.productTypeID : this.selectedFacility.productTypeID;

    this.renewalDraft = new RenewalDraftApplicationModel(JSON.stringify(renewalApplicationDraft), this.erisLoginService.getUserId());
    
    if(this.editMode){
      this.renewalDraft['id'] = this.applicationDetail['draftID'];
      this.renewalDraft['applicationNumber'] = this.applicationDetail['applicationNumber'];
    }
      
    this.applicationService.saveDraftApplication(this.renewalDraft).subscribe(res => {
      if (res) {
        this.alertService.success('Successfully saved renewal application');
        this.router.navigateByUrl('/applications/all');

      } else {
        this.alertService.error('Unable to save draft for application. Please try again later');
      }
    }, error => {})
  }

  /**
   * CreateApplicationAsync requires PaymentInfo.Payment (ServiceProvider) to mint a bill.
   * File-upload only emits receipt + documentID; renewal historically never set payment method.
   */
  private ensurePaymentPayload(): void {
    const receipt = this.renewalForm?.get('paymentInfo')?.get('receiptNumber')?.value;
    if (!this.paymentInfo) {
      this.paymentInfo = new PaymentInfo({ recieptNumber: receipt });
    }
    if (receipt) {
      this.paymentInfo.recieptNumber = receipt;
    }
    const existing = this.paymentInfo.payment || {};
    const provider = existing.ServiceProvider || existing.serviceProvider || 'CASH';
    this.paymentInfo.payment = Object.assign({}, existing, { ServiceProvider: provider });
  }

  private discardDraftIfNeeded(): void {
    const draftId = this.draftApplicationId
      || (this.applicationDetail && this.applicationDetail['draftID']);
    if (!this.draftMode || !draftId) {
      return;
    }
    this.applicationService.deleteDraftApplication(draftId).subscribe(() => {
      console.log('Draft version of the application has been removed');
    }, () => {
      console.log('Unable to remove the draft version of the application');
      this.alertService.error('Unable to remove the draft version of the application');
    });
  }

  
  submitClicked() {
    if (this.hasUnsafePaymentReceipt()) {
      this.alertService.error(NO_SCRIPT_INPUT_MESSAGE);
      return;
    }
    this.createChecklistObject();
    this.ensurePaymentPayload();
    this.spinner.show();
    const useEditPath = this.editMode && (!this.draftMode || this.applicationId);
    if (useEditPath) {
      this.applicationDetail.documents = this.documents;

      this.applicationDetail.checkListInstances = this.checklistInstances;
      this.applicationDetail.paymentInfos = [this.paymentInfo];
      this.renewalApplicationForEditing = new RenewalApplication(this.selectedFacility, this.documents,
        this.checklistInstances, this.paymentInfo, this.applicationDetail.id, this.applicantAgreesWithDeclaration);
      this.applicationService.editRenewalApplication(this.renewalApplicationForEditing).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully submitted application');
            this.discardDraftIfNeeded();
            this.router.navigateByUrl('/applications/list/' + this.applicationDetail.id);
          } else {
            this.alertService.error('Unable to submit application. Please try again later');
          }
        },
        err => {
          this.spinner.hide();
          this.alertService.error('Unable to submit application, ' + this.errorHandlerService.handleApiError(err));
        }
      );
    } else {
      const renewalApplication: RenewalApplication = new RenewalApplication(this.selectedFacility, this.documents,
        this.checklistInstances, this.paymentInfo, null, this.applicantAgreesWithDeclaration);

      this.applicationService.submitApplicationRenewal(renewalApplication).subscribe(
        res => {
          this.spinner.hide();
          if (res) {
            this.alertService.success('Successfully submitted application');
            this.discardDraftIfNeeded();
            this.router.navigateByUrl('/applications/list/' + res.id);
          } else {
            this.alertService.error('Unable to submit application. Please try again later');
          }
        },
        err => {
          this.spinner.hide();
          this.alertService.error(this.errorHandlerService.handleApiError(err));
        }
      );
    }
  }

  editSelectedFacility(selectedFacility) {
    this.router.navigate(['/edit/' + selectedFacility.applicationID], {queryParams: {ldeType: Constants.APPLICATION_TYPE_CODE_RENEWAL}});
  }

  legacyDataRequiresEditing() {
    return this.selectedFacility && this.selectedFacility.isLegacyData &&
      this.selectedFacility.applicationStatusCode !== Constants.LEGACY_DATA_EDITED_CODE;
  }

  applicantAgreesWithDeclarationEvent(agrees) {
    this.applicantAgreesWithDeclaration = agrees;
  }

  disableChecklistButtons(){
    return (this.applicationDetail && this.applicationDetail.applicationCategory.name === Constants.APPLICATION_TYPE_NAME_RENEWAL && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode));
  }

  getFIRDocumentRefs(){
    if(!this.applicationDetail || !([Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.applicationDetail.applicationStatusCode))){
      return undefined;
    }

    let editFields:FIRItem[] = JSON.parse(this.applicationDetail.editedFields);


        let groupIndex = editFields.findIndex(item => item.name === 'Documents');

        if(groupIndex === -1){
          return new FIRItem();
        }
        else{
          return editFields[groupIndex];
        }
  }
}
